import { STAGES, STAGE_LABELS } from "@/mocks/dashboard";

interface StageTrackerProps {
  currentStage: string;
  currentIndex: number;
}

export default function StageTracker({ currentStage, currentIndex }: StageTrackerProps) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between relative">
        {/* Connector line */}
        <div className="absolute top-4 left-0 right-0 h-px bg-dark-border z-0" />
        <div
          className="absolute top-4 left-0 h-px bg-electric-blue z-0 transition-all duration-700"
          style={{ width: `${(currentIndex / (STAGES.length - 1)) * 100}%` }}
        />

        {STAGES.map((stage, i) => {
          const done = i < currentIndex;
          const active = i === currentIndex;
          return (
            <div key={stage} className="relative z-10 flex flex-col items-center gap-2">
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full border-2 transition-all duration-300 ${
                  done
                    ? "bg-electric-blue border-electric-blue"
                    : active
                    ? "bg-electric-blue/20 border-electric-blue animate-glow-pulse"
                    : "bg-dark-card border-dark-border"
                }`}
              >
                {done ? (
                  <i className="ri-check-line text-deep-black text-sm font-bold" />
                ) : (
                  <span className={`text-xs font-bold ${active ? "text-electric-blue" : "text-silver-dim"}`}>{i + 1}</span>
                )}
              </div>
              <span className={`text-xs font-medium whitespace-nowrap ${active ? "text-electric-blue" : done ? "text-silver" : "text-silver-dim"}`}>
                {STAGE_LABELS[stage]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
